import { render, staticRenderFns } from "./advertorial.vue?vue&type=template&id=eceda572&scoped=true&"
import script from "./advertorial.vue?vue&type=script&lang=js&"
export * from "./advertorial.vue?vue&type=script&lang=js&"
import style0 from "./advertorial.vue?vue&type=style&index=0&id=eceda572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eceda572",
  null
  
)

export default component.exports